/* Sort by the same selected-variant price rendered on each card, across all pages. */
(() => {
  const sortedCards = (cards, direction) => cards.map((card, index) => ({
    card, index, price: Number(card.querySelector('[data-suri-price]')?.dataset.suriPrice)
  })).sort((a, b) => {
    if (!Number.isFinite(a.price) || !Number.isFinite(b.price)) return a.index - b.index;
    return (a.price - b.price) * direction || a.index - b.index;
  }).map(item => item.card);

  if (typeof module !== 'undefined' && module.exports) module.exports = { sortedCards };
  if (typeof customElements === 'undefined' || customElements.get('suri-price-sort')) return;

  // Price-sorted results use their own Show more pagination, beginning at page 1.
  // Preserve all filters and preview parameters when opening an old paginated URL.
  const entryUrl = new URL(location.href);
  if (/^price-(ascending|descending)$/.test(entryUrl.searchParams.get('sort_by') || '') && Number(entryUrl.searchParams.get('page')) > 1) {
    entryUrl.searchParams.delete('page');
    location.replace(entryUrl.href);
    return;
  }

  customElements.define('suri-price-sort', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
      } else queueMicrotask(() => this.initialize());
    }
    disconnectedCallback() { this.controller?.abort(); }
    async initialize() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      const grid = this.querySelector('#product-grid');
      if (!grid) return;
      const status = this.querySelector('[data-price-sort-status]');
      const more = this.querySelector('[data-price-sort-more]');
      const cards = Array.from(grid.children);
      const pageSize = Number(this.dataset.pageSize) || 24;
      try {
        let next = this.dataset.next;
        const visited = new Set();
        while (next) {
          const url = new URL(next, location.origin);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid collection pagination');
          visited.add(url.href);
          url.searchParams.set('section_id', grid.dataset.id);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Collection request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = doc.querySelector('suri-price-sort');
          if (!page) throw new Error('Missing collection page');
          cards.push(...page.querySelectorAll('#product-grid > li'));
          next = page.dataset.next;
        }
        if (!this.isConnected) return;
        const ordered = sortedCards(cards, this.dataset.direction === 'descending' ? -1 : 1);
        grid.replaceChildren();
        let shown = 0;
        const showMore = () => {
          const nextCards = ordered.slice(shown, shown + pageSize);
          grid.append(...nextCards);
          if (typeof checkSwatches === 'function') checkSwatches();
          shown += nextCards.length;
          more.hidden = shown >= ordered.length;
          status.textContent = `Showing ${shown} of ${ordered.length} products`;
        };
        more.addEventListener('click', showMore, { signal: this.controller.signal });
        showMore();
      } catch (error) {
        if (error.name === 'AbortError' || !this.isConnected) return;
        status.textContent = 'Unable to finish sorting. Please refresh or choose another sort order.';
        more.hidden = true;
      } finally {
        if (this.isConnected) { grid.removeAttribute('aria-busy'); grid.style.visibility = ''; }
      }
    }
  });
})();
